function addFlag({ contentId, userId, flagType, reason, violationType }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/flags`;
  return apiClient.post(route, { contentId, userId, flagType, reason, violationType });
}

export default {
  addFlag
};
